import "./style.css";
const PageTitle = ({ title }) => {
  return (
    <div className="pageTitleContainer">
      <p className={`${title ? "pageTitleHeader" : ""}`}>{title}</p>
    </div>
  );
};

export default PageTitle;
